import { IS_TEST } from './index'
export const APPIDS = {
  // 佛山
  fs: {
    appid: 'cli_a77e597418d9500d',
    type: 'FS',
    appSecret: 'S8Zrfgq7PysbGwhes1hCZf0esURxHVkI'
  },
  // 陆渔养殖中心 （佛山 1） 
  fs1: {
    appid: 'cli_a8c813afe26f500e',
    type: 'FS1',
    appSecret: 'zcRn7vOZx5CgeacqNK9WNghyVLzhkGWz'
  },
  // 珠海斗门
  fishview: {
    appid: 'cli_a75d2e2f3d79d01c',
    type: null,
    appSecret: 'HUr1rA3lGnjd7kXpVRTRLcS4Vw2SiNj1'
  },
  // 湖北  
  hb: {
    appid: 'cli_a892d7591db8900c',
    type: 'HB',
    appSecret: 'lh3ogccUg8Im9S6goVC3JhAYj5w7mzaO'
  },
}

